import { render, staticRenderFns } from "./DoctorInfo.vue?vue&type=template&id=3325db86&scoped=true"
import script from "./DoctorInfo.vue?vue&type=script&lang=js"
export * from "./DoctorInfo.vue?vue&type=script&lang=js"
import style0 from "./DoctorInfo.vue?vue&type=style&index=0&id=3325db86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3325db86",
  null
  
)

export default component.exports